module.exports = __webpack_public_path__ + "static/img/22d.837212e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/22d.jpg
// module id = AyhF
// module chunks = 0